import { connect } from "react-redux";
import ContentLoader from "react-content-loader";
import React, { Component, Fragment } from "react";

import { sharedRequests } from "@/api/(requests)/shared";

import Accordion from "../../UI/Accordion/Accordion";
import Button from "../../UI/Button";
import CardSecondary from "../../UI/Card/CardSecondary";
import { formatMobileNumber } from "../../../utils/formInputUtils";
import images from "../../../utils/images";
import Input from "../../UI/Input";
import {
  loadPatientInsuranceImagesUrlToState,
  loadReferralInsuranceImagesUrlToState,
} from "../../../containers/Dashboard/Patient/PatientInsurance";

class CommonUserDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editEmail: false,
      expandedImg: null,
      insuranceImageTypes: null,
      insuranceImageUrls: null,
      newEmail: "",
    };
  }

  componentDidMount() {
    (async () => {
      if (this.props.isReferral) {
        loadReferralInsuranceImagesUrlToState(this.props.details, this);
      } else {
        loadPatientInsuranceImagesUrlToState(this.props.details, this);
      }
    })();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.details.email === "" && this.props.details.email !== "") {
      this.componentDidMount();
    }
  }

  Loader = () => (
    <ContentLoader
      height={500}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      speed={2}
      width={350}
    >
      <rect height="10" rx="3" ry="3" width="150" x="125" y="30" />
      <rect height="10" rx="3" ry="3" width="150" x="125" y="60" />
      <circle cx="45" cy="50" r="30" />
      <rect height="10" rx="3" ry="3" width="70" x="25" y="160" />
      <rect height="10" rx="3" ry="3" width="70" x="25" y="190" />
      <rect height="10" rx="3" ry="3" width="70" x="25" y="250" />
      <rect height="10" rx="3" ry="3" width="70" x="25" y="280" />
      <rect height="10" rx="3" ry="3" width="70" x="25" y="340" />
      <rect height="10" rx="3" ry="3" width="70" x="25" y="370" />
      <rect height="10" rx="3" ry="3" width="70" x="25" y="430" />
      <rect height="10" rx="3" ry="3" width="70" x="25" y="460" />
    </ContentLoader>
  );

  render() {
    /** no http calls in render */

    return (
      <Fragment>
        {this.state.expandedImg && (
          <div className="ExpandedImagePopUp position-fixed d-flex align-items-center tw:justify-center">
            <div className="ExpandedImagePopUp__inner-wide d-flex flex-column text-center position-absolute">
              <h2 className="fs-17 mt-4 tw:font-bold">Card Image</h2>
              <embed
                alt=""
                className="PatientProfile__insurance-image-preview-expand"
                src={this.state.expandedImg}
              />

              <div className="ExpandedImagePopUp__btn-wpr d-flex pt-3 my-4 tw:justify-center">
                <Button
                  className="Btn Btn--otl-pri Btn-sm mx-2"
                  onClick={() => this.expandImg(null)}
                  type="button"
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        )}

        {this.props.details ? (
          <div>
            <CardSecondary className="mx-lg-auto mt-4 mt-lg-5 px-3 px-lg-4">
              {this.props.children}
              <hr className="m-0" />
              <div className="px-3 mt-4">
                {this.props.details && this.setDetails(this.props.details)}
              </div>
            </CardSecondary>
          </div>
        ) : (
          <div>
            <CardSecondary className="mx-lg-auto mt-4 mt-lg-5 px-3 px-lg-4">
              {this.Loader()}
            </CardSecondary>
          </div>
        )}
      </Fragment>
    );
  }

  updateReferralEmail = async (referralCode) => {
    let data = {};

    data["referralCode"] = referralCode;
    data["email"] = this.state.newEmail;
    await sharedRequests.update_referral({ data });
    this.props.getReferral();
  };

  setDetails = (details) => {
    if (details.email !== "" && this.state.newEmail === "" && !this.state.editEmail) {
      this.setState({ newEmail: details.email });
    }

    return (
      <div>
        <div>
          <div className="mb-4">
            <p className="mb-2 fs-14 tw:font-bold">Date of Birth</p>
            <p className="mb-0 fs-14">{details.dob}</p>
          </div>
          <div className="mb-4">
            <p className="mb-2 fs-14 tw:font-bold">Gender</p>
            <p className="mb-0 fs-14">{details.gender}</p>
          </div>
          <div className="mb-4">
            <p className="mb-2 fs-14 tw:font-bold">Mobile Number</p>
            <p className="mb-0 fs-14">{formatMobileNumber(details.mobile)}</p>
          </div>

          <div className="mb-4">
            <p className="mb-2 fs-14 tw:font-bold">Email</p>
            <div className="d-flex align-items-center">
              {this.state.editEmail ? (
                <Input
                  className="w-100"
                  onChange={(e) => this.setState({ newEmail: e.target.value })}
                  value={this.state.newEmail}
                />
              ) : (
                <p className="mb-0 fs-14">{details.email}</p>
              )}

              {this.props.isReferral ? (
                !this.state.editEmail ? (
                  <div className="cursor">
                    <img
                      alt="view icon"
                      className="ml-2"
                      onClick={() => this.setState({ editEmail: !this.state.editEmail })}
                      src={images("./icons/edit-pencil.svg")}
                    />
                  </div>
                ) : (
                  <div className="cursor">
                    <img
                      alt="view icon"
                      className="ml-2"
                      onClick={() => {
                        if (details.email === this.state.newEmail) {
                          this.setState({ editEmail: false });

                          return;
                        }

                        this.updateReferralEmail(details.referralCode).then(() =>
                          this.setState({
                            editEmail: !this.state.editEmail,
                          }),
                        );
                      }}
                      src={images("./icons/add-icon.svg")}
                    />
                  </div>
                )
              ) : null}
            </div>
          </div>

          <div className="mb-2">
            <p className="mb-2 fs-16 tw:font-bold">Address</p>
          </div>
          <div className="mb-2">
            <p className="mb-2 fs-14 tw:font-bold">Street</p>
            <p className="mb-0 fs-14">{details.address.street}</p>
          </div>
          <div className="mb-2">
            <p className="mb-2 fs-14 tw:font-bold">City</p>
            <p className="mb-0 fs-14">{details.address.city}</p>
          </div>
          <div className="mb-2">
            <p className="mb-2 fs-14 tw:font-bold">State</p>
            <p className="mb-0 fs-14">{details.address.state}</p>
          </div>
          <div className="mb-2">
            <p className="mb-2 fs-14 tw:font-bold">Zip</p>
            <p className="mb-0 fs-14">{details.address.zip_code}</p>
          </div>
        </div>

        <hr className="m-0" />

        <div className="accordion" id="AptiAccordion">
          <Accordion
            ariaControls="collapseOne"
            ariaLabelledby="headingOne"
            contentId="collapseOne"
            dataTarget="#collapseOne"
            info={this.getEmergencyContact(this.props.details)}
            text="Emergency Contact"
          />

          <hr className="m-0" />

          {this.state.insuranceImageUrls && (
            <Accordion
              ariaControls="collapseTwo"
              ariaLabelledby="headingTwo"
              contentId="collapseTwo"
              dataTarget="#collapseTwo"
              info={this.getPrimaryInsuranceInformation(
                this.props.details,
                this.state.insuranceImageUrls,
              )}
              text="Primary Insurance Information"
            />
          )}

          {details.secondary_insurance.member_id &&
            details.secondary_insurance.carrier &&
            details.secondary_insurance.state && (
              <>
                <hr className="m-0" />
                {this.state.insuranceImageUrls && (
                  <Accordion
                    ariaControls="collapseThree"
                    ariaLabelledby="headingThree"
                    contentId="collapseThree"
                    dataTarget="#collapseThree"
                    info={this.getSecondaryInsuranceInformation(
                      this.props.details,
                      this.state.insuranceImageUrls,
                    )}
                    text="Secondary Insurance Information"
                  />
                )}{" "}
              </>
            )}
        </div>
      </div>
    );
  };

  getEmergencyContact = (details) => {
    return [
      { property: "Person Name", value: details.emergency_contact_person },
      { property: "Contact Number", value: details.emergency_contact_number },
    ];
  };

  expandImg = (url) => {
    this.setState({ expandedImg: url });
  };

  getPrimaryInsuranceInformation = (details, insuranceImgUrls) => {
    return [
      { property: "Insurance Company", value: details.primary_insurance.carrier },
      { property: "Member ID", value: details.primary_insurance.member_id },
      { property: "Group ID", value: details.primary_insurance.group_id },
      { property: "Is ASO", value: details.is_aso },
      { property: "State of Insurance Plan", value: details.primary_insurance.state },
      {
        property: "Policy Holder Date of Birth",
        value: details.primary_insurance.policy_dob,
      },
      { property: "Policy Holder", value: details.primary_insurance.policy_holder_name },
      {
        onclick: this.expandImg,
        property: "Insurance Card Images",
        type: "img",
        value: [insuranceImgUrls.pfUrl, insuranceImgUrls.pbUrl],
      },
    ];
  };

  getSecondaryInsuranceInformation = (details, insuranceImgUrls) => {
    return [
      { property: "Insurance Company", value: details.secondary_insurance.carrier },
      { property: "Member ID", value: details.secondary_insurance.member_id },
      { property: "Group ID", value: details.secondary_insurance.group_id },
      { property: "State of Insurance Plan", value: details.secondary_insurance.state },
      {
        property: "Policy Holder Date of Birth",
        value: details.secondary_insurance.policy_dob,
      },
      { property: "Policy Holder", value: details.secondary_insurance.policy_holder_name },
      {
        onclick: this.expandImg,
        property: "Insurance Card Images",
        type: "img",
        value: [insuranceImgUrls.sfUrl, insuranceImgUrls.sbUrl],
      },
    ];
  };
}

const mapStateToProps = (state) => {
  return {
    timezone: state.auth.timezone,
  };
};

export default connect(mapStateToProps)(CommonUserDetails);
